"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _head = _interopRequireDefault(require("lodash/fp/head"));

var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));

var _Resizer = _interopRequireDefault(require("../resizer/Resizer"));

var _TreeSidebar = _interopRequireDefault(require("./TreeSidebar"));

var _TreeCategory = _interopRequireDefault(require("./TreeCategory"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getSidebarBodyRef = function getSidebarBodyRef(sidebarRef) {
  return (0, _head.default)(sidebarRef.current.getElementsByClassName('AssetTreeBody'));
};

var getWidthInBoundaries = function getWidthInBoundaries(minWidth, maxWidth, width) {
  if (width > 0 && width < minWidth) {
    return minWidth;
  }

  if (width > 0 && width > maxWidth) {
    return maxWidth;
  }

  if (width > 0 && width > maxWidth) {
    return maxWidth;
  }

  return width;
};

var getCurrentCategoryElement = function getCurrentCategoryElement(children, currentCategoryId) {
  return (0, _isArray.default)(children) ? children.find(function (child) {
    return child && child.props.id === currentCategoryId;
  }) : children;
};

var renderTreesOffscreen = function renderTreesOffscreen(children, categoryId) {
  return _react.default.Children.map(children, function (child) {
    var offscreenClasses = (0, _classnames.default)('TreeOffscreenWrapper', child.props.id !== categoryId && 'position-offscreen');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: offscreenClasses
    }, child);
  });
};

var AssetTree = /*#__PURE__*/(0, _react.memo)(function (props) {
  var className = props.className,
      resizable = props.resizable,
      width = props.width,
      maxWidth = props.maxWidth,
      minWidth = props.minWidth,
      height = props.height,
      bordered = props.bordered,
      currentCategoryId = props.currentCategoryId,
      isOpen = props.isOpen,
      useOffscreen = props.useOffscreen,
      fly = props.fly,
      onCategoryChange = props.onCategoryChange,
      onToggleTree = props.onToggleTree,
      onResizeEnd = props.onResizeEnd,
      children = props.children;

  var getSidebarMode = function getSidebarMode(isFly) {
    return isFly ? AssetTree.MODE_FLY : AssetTree.MODE_FLUID;
  };

  var _useState = (0, _react.useState)(parseInt(width, 10)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      treeWidth = _useState2[0],
      setTreeWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isResize = _useState4[0],
      setIsResize = _useState4[1];

  var _useState5 = (0, _react.useState)(getSidebarMode(fly)),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      sidebarMode = _useState6[0],
      setSidebarMode = _useState6[1];

  var sidebarRef = (0, _react.useRef)(); // Update internal state when props change

  (0, _react.useEffect)(function () {
    return setTreeWidth(width);
  }, [width]);
  (0, _react.useEffect)(function () {
    return setSidebarMode(getSidebarMode(fly));
  }, [fly]);
  var classes = (0, _classnames.default)('AssetTree', className, !isOpen && 'closed', bordered && 'panel panel-default', sidebarMode === AssetTree.MODE_FLY ? 'fly' : 'fluid');
  var resizeLimitClasses = (0, _classnames.default)('AssetTreeResizeLimit', isResize && 'display-block');
  var resizeIndicatorPosition = maxWidth || window.innerWidth * 0.5;
  var resizeLimitStyle = {
    left: resizeIndicatorPosition
  };
  var categoryId = currentCategoryId || 0;
  var firstChild = (0, _head.default)(children);
  var category = currentCategoryId ? getCurrentCategoryElement(children, currentCategoryId) : firstChild;
  var style = {
    width: treeWidth,
    height: height
  };

  var handleToggleTreeContent = function handleToggleTreeContent() {
    return onToggleTree(!isOpen);
  };

  var handleSelectCategory = function handleSelectCategory(selectedCategoryId) {
    onCategoryChange(selectedCategoryId);

    if (!isOpen) {
      handleToggleTreeContent();
    } else if (isOpen && currentCategoryId === selectedCategoryId) {
      handleToggleTreeContent();
    }
  };

  var handleResize = function handleResize(diff) {
    var halfWindowWidth = window.innerWidth * 0.5;
    var usedMaxWidth = maxWidth || halfWindowWidth;
    var updatedWidth = treeWidth - diff;
    var newWidth = getWidthInBoundaries(minWidth, usedMaxWidth, updatedWidth); // Check for sidebar with if it is half window size. If it was before but the sidebar was resized so it is
    // no longer walf window size, set the sidebar with to hals window size to avoid jumping sidebar to old width

    setTreeWidth(newWidth);
  };

  var handleResizeStart = function handleResizeStart() {
    var body = getSidebarBodyRef(sidebarRef);

    if (body) {
      body.classList.add('pointer-events-none');
    }

    setIsResize(true);
  };

  var handleResizeEnd = function handleResizeEnd() {
    var body = getSidebarBodyRef(sidebarRef);

    if (body) {
      body.classList.remove('pointer-events-none');
    }

    setIsResize(false);
    onResizeEnd();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style,
    ref: sidebarRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: resizeLimitClasses,
    style: resizeLimitStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'AssetTreeContent'
  }, /*#__PURE__*/_react.default.createElement(_TreeSidebar.default, {
    onSelectCategory: handleSelectCategory,
    currentCategoryId: currentCategoryId,
    onClick: handleToggleTreeContent
  }, (0, _isArray.default)(children) ? children : [children]), /*#__PURE__*/_react.default.createElement("div", {
    className: 'AssetTreeBody'
  }, useOffscreen ? renderTreesOffscreen(children, categoryId) : category)), resizable && isOpen && /*#__PURE__*/_react.default.createElement(_Resizer.default, {
    onResizeStart: handleResizeStart,
    onResize: handleResize,
    onResizeEnd: handleResizeEnd,
    direction: _Resizer.default.HORIZONTAL,
    position: _Resizer.default.RIGHT
  }));
});
AssetTree.displayName = 'AssetTree';
AssetTree.MODE_FLY = 'fly';
AssetTree.MODE_FLUID = 'fluid';
AssetTree.defaultProps = {
  width: 350,
  minWidth: 100,
  maxWidth: 0,
  resizable: true,
  disableEsc: false,
  bordered: false,
  fly: false,
  isOpen: true,
  onToggleTree: function onToggleTree() {},
  children: [],
  onCategoryChange: function onCategoryChange() {},
  onResizeEnd: function onResizeEnd() {},
  useOffscreen: false
};
AssetTree.propTypes = {
  fly: _propTypes.default.bool,
  resizable: _propTypes.default.bool,
  bordered: _propTypes.default.bool,
  // When sidebar is resizable it will take the provided width in px only
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minWidth: _propTypes.default.number,
  maxWidth: _propTypes.default.number,
  height: _propTypes.default.number,
  isOpen: _propTypes.default.bool,
  onToggleTree: _propTypes.default.func,
  currentCategoryId: _propTypes.default.string.isRequired,
  onCategoryChange: _propTypes.default.func,
  className: _propTypes.default.string,
  onResizeEnd: _propTypes.default.func,
  useOffscreen: _propTypes.default.bool,
  children: function children(props, propName, componentName) {
    var prop = props[propName];
    var error = null;

    _react.default.Children.forEach(prop, function (child) {
      if (child.type !== _TreeCategory.default) {
        error = new Error("`".concat(componentName, "` children should be of type `TreeCategory`."));
      }
    });

    return error;
  }
};
var _default = AssetTree;
exports.default = _default;